export const CalendarItemKind = {
  appointment: 'appointment',
  followUp: 'follow_up',
  taskDeadline: 'task_deadline',
  taskGroup: 'task_group',
}

export const CalendarSource = {
  appointment: 'appointment',
  followUp: 'follow_up',
  taskDeadline: 'task_deadline',
}

export const CalendarAppointmentStatus = {
  cancelled: 'cancelled',
  confirmed: 'confirmed',
}
